import React from 'react';

export const CloseSmIcon = (): React.ReactElement => (
  <svg
    aria-labelledby="close-button"
    role="img"
    height="24"
    width="24"
    viewBox="0 0 18 18"
  >
    <path
      fillRule="evenodd"
      d="M9 7.598L5.443 4.04a.992.992 0 1 0-1.402 1.403L7.597 9l-3.556 3.557a.992.992 0 1 0 1.402 1.402L9 10.403l3.556 3.556a.992.992 0 0 0 1.403-1.402L10.403 9l3.556-3.556a.992.992 0 1 0-1.402-1.403L9 7.598z"
      clipRule="evenodd"
    />
  </svg>
);
